 
<template>
<div class="min-h-screen w-[90%] mx-auto md:w-full">
    <div class="flex items-center mb-4 gap-6">
      <!-- <button @click="goBack" class="mr-3 text-gray-700 hidden sm:block">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button> -->
       <!-- <button 
            class="flex items-center justify-center w-6 h-8 rounded-full"
            v-if="isDesktop"
        >
            <UIcon name="i-heroicons-arrow-left" class="w-6 h-6 md:w-8 md:h-8 text-leftArrow" />
        </button> -->
      <h1 class="text-xl sm:text-2xl font-semibold text-gray-900 hidden sm:block" style="font-size: 28px; font-family: Rubik; line-height: 100%;font-weight: 600; ">Frequently Asked Questions</h1>
    </div>
 
    <!-- Categories -->
    <div class="flex gap-2 overflow-x-auto pb-2">
      <button
        v-for="category in categories"
        :key="category"
        @click="selectedCategory = category"
        :class="[
          'px-4 py-2 rounded-full whitespace-nowrap text-base font-medium transition-colors',
          selectedCategory === category
            ? 'bg-white text-gray-900 border-b-2 border-gray-900'
            : 'text-gray-600 hover:text-gray-900'
        ]"
      >
        {{ category }}
      </button>
    </div>
 
    <!-- FAQ items -->
    <div class="space-y-[12px] w-full">
      <div
        v-for="(faq, index) in faqs"
        :key="index"
        class="bg-white rounded-lg shadow-sm overflow-hidden w-full"
      >
        <button
          @click="toggleFAQ(index)"
          class="w-full px-4 pt-4 flex items-start justify-between text-[14px] md:text-[16px] text-left  transition-colors"
        >
          <span class="font-medium text-gray-900 text-sm sm:text-base  md:text-medium">{{ faq.question }}</span>
          <svg
            :class="['w-5 h-5 text-gray-600  w-[24px] h-[24px] transition-transform', expandedIndex === index ? 'rotate-180' : '']"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
 
        <div
          :class="[
            'overflow-hidden transition-all duration-300 ease-in-out px-4 pb-2 md:pb-4 font-[Rubik] text-[14px] md:text-[16px] text-gray-700 space-y-2',
            expandedIndex === index ? 'max-h-[800px] opacity-100' : 'max-h-0 opacity-0'
          ]"
        >
          <p>{{ faq.description }}</p>
          <ul class="space-y-1 ml-4">
            <li v-for="(benefit, idx) in faq.benefits" :key="idx" class="flex items-start">
              <span class="mr-2">•</span>
              <span>{{ benefit }}</span>
            </li>
          </ul>
          <!-- <p class="text-gray-600">{{ faq.additionalInfo }}</p>
          <p class="text-sm text-gray-500">{{ faq.terms }}</p> -->
 
          <!-- <button class="flex items-center text-teal-700 font-medium mt-2 hover:text-teal-800">
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" stroke-width="2"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 8l6 4-6 4V8z"/>
            </svg>
            Watch video
          </button> -->
        </div>
      </div>
    </div>
 
    <!-- Show More -->
    <!-- <button
      class="w-full mt-4 py-2 font-medium flex items-center justify-center text-base text-primary-500 hover:text-primary-500"
    >
      <span>Show More</span>
      <svg class="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button> -->
 
    <!-- Got It -->
  <div class="fixed bottom-0 left-0 w-full bg-white rounded-t-xl shadow-lg flex justify-center py-4 border-t z-50 md:hidden p-4">
  <button
    class="w-full h-[40px] bg-primary text-white py-[10px] rounded-[8px] font-[14px] font-medium font-semibold hover:opacity-90 transition-opacity text-base"
    @click="navToProfile"
  >
    GOT IT
  </button>
</div>
  </div>
</template>
 
 
<script setup lang="ts">
import { computed, ref } from 'vue';
import { useFaqSchema, type FaqItem } from '~/composables/useFaqSchema';
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

const { isMobile, isDesktop } = useDevice();
const navToProfile = () => {
  navigateTo({ path: '/account/profile' });
};
const categories: string[] = [];
const selectedCategory = ref('Food');
const expandedIndex = ref<number | null>(0);

type LocalFaq = {
  question: string;
  description?: string;
  benefits?: string[];
};
const runtimeConfig = useRuntimeConfig();
const partnerName = usePartnerDisplayName(runtimeConfig.public.partnerCode);
const faqs = ref<LocalFaq[]>([
  {
    question: "How do I track my order?",
    benefits: [
      "Go to the 'My Orders' section in your profile.",
      "Select the specific order to view its current status and delivery updates.",
    ],
  },
  {
    question: "Can I cancel or return an order?",
    description: "Yes, you can, provided the product is eligible for cancellations, returns, or exchanges.",
    benefits: [
      "Cancellations: Navigate to 'My Orders,' select the order, and choose 'Cancel Order'.",
      "Returns or Exchanges: Select the order and follow the return process as per the seller's policy.",
    ],
  },
  {
    question: `Are there delivery charges on ${partnerName}?`,
    benefits: [
      "Delivery charges depend on the seller, order size, and location. Any applicable charges will be clearly displayed at checkout.",
    ],
  },
  {
    question: "What payment options are available?",
    benefits: [
      `${partnerName} supports payments via cards, UPI, and net banking.`,
    ],
  },
  {
    question: "Can I apply discount codes or coupons?",
    description: "Yes, valid discount codes or coupons can be applied during checkout.",
    benefits: [
      "Yes, you can apply valid discount codes or coupons during checkout. Enter the coupon code in the designated field in your cart to avail the discounts.",
    ],
  },
  {
    question: "What should I do if I face issues with my order?",
    benefits: [
      "Visit the 'My Orders' section and select the specific order.",
      "Go to ‘Help & Support’ to raise a query or contact customer service.",
    ],
  },
]);

const buildAnswer = (faq: LocalFaq): string => {
  const parts: string[] = [];
  if (faq.description) {
    parts.push(`<p>${faq.description}</p>`);
  }
  if (faq.benefits?.length) {
    const listItems = faq.benefits.map((benefit) => `<li>${benefit}</li>`).join('');
    parts.push(`<ul>${listItems}</ul>`);
  }
  return parts.join('');
};

const faqSchemaItems = computed<FaqItem[]>(() =>
  faqs.value
    .map((faq) => ({
      question: faq.question,
      answer: buildAnswer(faq),
    }))
    .filter((item) => item.answer.trim().length > 0),
);

useFaqSchema(faqSchemaItems);

const toggleFAQ = (index: number) => {
  expandedIndex.value = expandedIndex.value === index ? null : index;
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: `FAQ_${faqs.value[index].question}`,
  });
};

const goBack = () => {
  window.history.back();
};

const navToHome = () => {
  navigateTo({ path: '/' });
};
</script>
 
 
